module.exports = __webpack_public_path__ + "img/1.71bfac65.png";